import React, { useEffect } from "react";
import { clockInService } from "../../../api/services/clockInService";
import {
  canClockIn,
  setClockInLoader,
} from "../../../infra/aggregates/clockInSlice";
//import { clockInService } from "../../../api/services/clockInService";
import { useAppDispatch, useAppSelector } from "../../../infra/hooks";
interface PropsValue {
  setcallbackempLocation: (data: any) => void;
}
function DTODashboardClockIn({ setcallbackempLocation }: PropsValue) {
  const selector = useAppSelector((state) => state.authSlice);
  async function callGetEmpLocation(emp_id: number, company_id: number) {
    const response: any = await clockInService.getEmployeeLocationList(
      emp_id,
      company_id
    );
    if (response) {
      // console.log("getEmployeeLocationList------------->>>>>>>", response);
      return setcallbackempLocation(response?.data);
    }
  }

  useEffect(() => {
    callGetEmpLocation(selector.emp_id, selector.company_id);
  }, []);
  return <></>;
}
export default DTODashboardClockIn;
